import React, { useState, useEffect } from "react"
import { useAuth } from "../contexts/AuthContext"
import { ehLimitado, paginasLimitado } from "../utils/usuarioLimitado"

interface Props { pagina: string; setPagina: (p: string) => void }

const GRUPOS = [
  {
    id: "dashboard_grupo", label: "", semCabecalho: true, aberto: true, adminOnly: false,
    itens: [
      { id:"dashboard", icon:"gauge", label:"Dashboard" },
    ]
  },
  {
    id: "cadastros", label: "Cadastros", icon:"folder-open", aberto: true, adminOnly: false,
    itens: [
      { id:"clientes",     icon:"buildings",          label:"Clientes" },
      { id:"usuarios",     icon:"users",              label:"Usuários" },
      { id:"chips",        icon:"sim-card",           label:"Chips SIM" },
      { id:"rastreadores", icon:"broadcast",          label:"Rastreadores" },
      { id:"ativos",       icon:"car",                label:"Ativos" },
      { id:"marcas_modelos", icon:"tag",              label:"Marcas e Modelos" },
      { id:"tipos_combustivel", icon:"gas-pump",       label:"Tipos de Combustível" },
      { id:"motoristas",   icon:"identification-badge", label:"Motoristas" },
      { id:"grupos",       icon:"squares-four",       label:"Grupos" },
      { id:"whatsapp",     icon:"whatsapp-logo",      label:"WhatsApp" },
    ]
  },
  {
    id: "monitoramento", label: "Monitoramento", icon:"monitor", aberto: true, adminOnly: false,
    itens: [
      { id:"mapa",       icon:"map-trifold",   label:"Mapa ao vivo" },
      { id:"video_mapa", icon:"video-camera",  label:"Vídeo Monitoramento" },
      { id:"replay",     icon:"play-circle",   label:"Trajetos" },
    ]
  },
  {
    id: "frota", label: "Gestão de Frota", icon:"steering-wheel", aberto: true, adminOnly: false,
    itens: [
      { id:"alertas",        icon:"bell-ringing",  label:"Alertas" },
      { id:"config_alertas", icon:"sliders",       label:"Config. Alertas" },
      { id:"cercas",         icon:"polygon",       label:"Cercas Virtuais" },
      { id:"pontos",         icon:"map-pin",       label:"Pontos de Interesse" },
      { id:"manutencao",     icon:"wrench",        label:"OS Manutenção" },
      { id:"comandos",       icon:"terminal",           label:"Comandos" },
      { id:"abastecimento",  icon:"gas-pump",      label:"Abastecimento" },
      { id:"viagens", icon:"suitcase-rolling", label:"Viagens e Despesas" },
      { id:"lancamentos", icon:"receipt", label:"Lançamentos Manuais" },
      { id:"meus_veiculos", icon:"car", label:"Meus Veículos" },
      { id:"pneus", icon:"tire", label:"Controle de Pneus" },
      { id:"checklist_modelos", icon:"check-square",  label:"Modelos de Checklist" },
      { id:"checklist_respostas", icon:"clipboard-text", label:"Checklists Preenchidos" },
      { id:"checklist_conformidade", icon:"calendar-check", label:"Conformidade de Checklist" },
    ]
  },
  {
    id: "relatorios_grupo", label: "Relatórios", icon:"chart-bar", aberto: false, adminOnly: false,
    itens: [
      { id:"relatorios", icon:"chart-line-up", label:"Telemetria" },
      { id:"areas_visitadas", icon:"map-trifold", label:"Áreas Visitadas" },
    ]
  },
  {
    id: "tecnico", label: "Técnico", icon:"toolbox", aberto: false, adminOnly: false,
    itens: [
      { id:"os_tecnico",    icon:"clipboard-text", label:"OS Técnico" },
      { id:"relatorios_os", icon:"file-text",      label:"Relatórios de OS" },
    ]
  },
  {
    id: "financeiro_grupo", label: "Financeiro", icon:"currency-dollar", aberto: false, adminOnly: false,
    itens: [
      { id:"planos",        icon:"list-checks",    label:"Planos" },
      { id:"licencas",      icon:"key",            label:"Licenças" },
      { id:"contratos",     icon:"file-signature", label:"Contratos" },
      { id:"fechamento",    icon:"calendar-check", label:"Fechamento Mensal" },
      { id:"financeiro",    icon:"credit-card",    label:"Financeiro" },
      { id:"contas_pagar",  icon:"receipt",        label:"Contas a Pagar" },
    ]
  },
  {
    id: "ia_grupo", label: "Inteligência Artificial", icon:"robot", aberto: false, adminOnly: false,
    itens: [
      { id:"manu", icon:"chat-circle-dots", label:"Manu (assistente)" },
      { id:"ia_admin", icon:"robot", label:"IA — Clientes" },
      { id:"ia_meu_uso", icon:"gauge", label:"IA — Meu uso" },
    ]
  },
  {
    id: "sistema_grupo", label: "Sistema", icon:"gear-six", aberto: false, adminOnly: true,
    itens: [
      { id:"auditoria",    icon:"clipboard-text",  label:"Auditoria" },
      { id:"email-config", icon:"envelope-simple", label:"Config. E-mail" },
      { id:"calendario-licenciamento", icon:"calendar-check", label:"Calendário Licenciamento" },
      { id:"email-logs",   icon:"envelope-open",   label:"Histórico E-mails" },
    ]
  },
]

function PhIcon({ name, size=18, color="currentColor" }: { name:string, size?:number, color?:string }) {
  return <i className={`ph-bold ph-${name}`} style={{ fontSize:size, color, lineHeight:1, display:"block" }} aria-hidden="true" />
}

function MenuItem({ id, icon, label, ativo, onClick, collapsed }: any) {
  return (
    <div onClick={onClick} title={collapsed ? label : undefined}
      style={{
        display:"flex", alignItems:"center", gap:10,
        padding: collapsed ? "10px 0" : "8px 14px 8px 24px",
        justifyContent: collapsed ? "center" : "flex-start",
        cursor:"pointer", transition:"all 0.15s",
        borderLeft: ativo ? "3px solid #0ea5e9" : "3px solid transparent",
        background: ativo ? "rgba(14,165,233,0.1)" : "transparent",
        borderRadius:"0 10px 10px 0", margin:"1px 6px 1px 0",
        position:"relative",
      }}>
      <span style={{ flexShrink:0, color: ativo ? "#38bdf8" : "#64748b", transition:"color 0.15s" }}>
        <PhIcon name={icon} size={17} color={ativo ? "#38bdf8" : "#64748b"} />
      </span>
      {!collapsed && (
        <span style={{ fontSize:12, fontWeight: ativo ? 600 : 400,
          color: ativo ? "#e2e8f0" : "#94a3b8", whiteSpace:"nowrap",
          overflow:"hidden", textOverflow:"ellipsis", flex:1 }}>
          {label}
        </span>
      )}
      {ativo && !collapsed && (
        <span style={{ width:5, height:5, borderRadius:"50%", background:"#0ea5e9", flexShrink:0 }} />
      )}
    </div>
  )
}

// =====================================================================
// QUEM VE CADA ITEM DO MENU
//  super   = area da PLATAFORMA: so o superadmin (nunca aparece pra usuario de cliente)
//  perm    = o usuario precisa ter pelo menos UMA dessas permissoes (tela Usuarios > Permissoes)
//  perfis  = so esses perfis (o superadmin sempre pode)
//  sem regra = todos os perfis
// Quando a sessao nao traz as permissoes, usa o padrao do perfil.
// =====================================================================
const REGRAS_MENU: Record<string, { super?: boolean; perm?: string[]; perfis?: string[]; explicita?: boolean; adminVe?: boolean; escondeSuper?: boolean }> = {
  // plataforma (financeiro, cadastros globais, tecnico, sistema)
  clientes: { super: true }, chips: { super: true }, marcas_modelos: { super: true }, tipos_combustivel: { super: true },
  planos: { super: true }, licencas: { super: true }, contratos: { super: true }, fechamento: { super: true },
  financeiro: { super: true }, contas_pagar: { super: true },
  os_tecnico: { super: true }, relatorios_os: { super: true },
  auditoria: { super: true }, "email-config": { super: true }, "calendario-licenciamento": { super: true }, "email-logs": { super: true },
  ia_admin: { super: true },
  ia_meu_uso: { perfis: ["admin"] },
  manu: { perm: ["ia_usar"], explicita: true },  // so quem foi liberado (ia_usar)
  // do cliente, controlados pelas permissoes do usuario
  usuarios: { perm: ["usuarios_ver"] },
  rastreadores: { super: true },
  ativos: { super: true },  // cadastro de ativos e da MoobiFleet (o cliente usa Meus Veiculos)
  motoristas: { perm: ["motoristas_ver"] },
  grupos: { perm: ["grupos_ver"] },
  whatsapp: { super: true },
  mapa: { perm: ["mapa_vivo"] },
  video_mapa: { perm: ["video_monitoramento"], explicita: true },  // so aparece se o superadmin liberar pro usuario
  replay: { perm: ["mapa_replay"] },
  alertas: { perm: ["alertas_ver"] },
  config_alertas: { perm: ["alertas_ver"], perfis: ["admin"] },
  cercas: { perm: ["ativos_ver"] },
  pontos: { perm: ["ativos_ver"] },
  manutencao: { perm: ["manutencao_ver"] },
  comandos: { perfis: ["admin"] },
  abastecimento: { perm: ["ativos_ver"] },
  viagens: { perm: ["viagens_ver", "viagens_editar", "viagens_lancar"], adminVe: true },  // o admin da empresa sempre ve; os demais so se liberados
  lancamentos: { perm: ["lancamento_manual"], adminVe: true },        // lancar abastecimento/despesa em nome do motorista: admin da empresa + quem ele liberar
  pneus: { perm: ["pneus_ver", "pneus_lancar", "pneus_gerir"], adminVe: true },                       // controle de pneus: admin da empresa + quem ele liberar (ver / lancar / gerir)
  meus_veiculos: { perm: ["ativos_simples"], adminVe: true },       // tela simples (ID e vencimentos): so quem recebeu o item
  checklist_modelos: { perfis: ["admin"] },
  checklist_respostas: { perm: ["ativos_ver"] },
  checklist_conformidade: { perm: ["ativos_ver"] },
  relatorios: { perm: ["rel_frota", "rel_manutencoes", "rel_alertas", "rel_hora_motor", "rel_trajeto", "rel_agendamentos"] },
  areas_visitadas: { perm: ["rel_trajeto"] },
}

const PERMISSOES_PADRAO: Record<string, string[]> = {
  admin: ["*"],
  operador: ["mapa_vivo", "mapa_popup", "mapa_replay", "ativos_ver", "rastreadores_ver", "motoristas_ver",
    "manutencao_ver", "manutencao_editar", "manutencao_concluir", "alertas_ver", "rel_frota", "rel_manutencoes", "rel_hora_motor"],
  visualizador: ["mapa_vivo", "mapa_popup", "ativos_ver"],
}

export function podeVer(id: string, u: any): boolean {
  if (!u) return false
  if (u.perfil === "superadmin") return !REGRAS_MENU[id]?.escondeSuper      // telas por empresa: o superadmin usa "acessar como"
  if (ehLimitado(u)) return paginasLimitado(u).includes(id)               // usuario limitado (so lancamentos / tela simples): so as telas dele
  const regra = REGRAS_MENU[id]
  if (!regra) return true
  if (regra.super) return false
  if (regra.perfis && !regra.perfis.includes(u.perfil)) return false
  if (regra.adminVe && u.perfil === "admin") return true  // administrador da empresa = gestor das viagens (o servidor trata igual)
  if (regra.perm) {
    const minhas: string[] = Array.isArray(u.permissoes) ? u.permissoes : (PERMISSOES_PADRAO[u.perfil] || [])
    if (regra.explicita && !regra.perm.some(p => minhas.includes(p))) return false  // permissao explicita: "*" nao vale
    if (!minhas.includes("*") && !regra.perm.some(p => minhas.includes(p))) return false
  }
  return true
}

export default function Sidebar({ pagina, setPagina }: Props) {
  const { usuario, logout, acessoComo, voltarAoMeuUsuario } = useAuth()
  const isAdmin = usuario?.perfil === "superadmin" || usuario?.perfil === "admin"

  // Sidebar sempre inicia colapsada. Expande automaticamente no hover.
  const [hovering, setHovering] = useState(false)
  const collapsed = !hovering

  const [grupos, setGrupos] = useState<Record<string,boolean>>(
    Object.fromEntries(GRUPOS.map(g=>[g.id, g.aberto]))
  )

  // Carregar Phosphor Icons
  useEffect(() => {
    if (!document.querySelector('#phosphor-css')) {
      const link = document.createElement('link')
      link.id = 'phosphor-css'
      link.rel = 'stylesheet'
      link.href = 'https://unpkg.com/@phosphor-icons/web@2.1.1/src/bold/style.css'
      document.head.appendChild(link)
    }
  }, [])

  const toggleGrupo = (id: string) => setGrupos(g=>({...g,[id]:!g[id]}))
  const gruposFiltrados = GRUPOS
    .map(g => ({ ...g, itens: g.itens.filter(it => podeVer(it.id, usuario)) }))
    .filter(g => (!g.adminOnly || isAdmin) && g.itens.length > 0)

  return (
    <>
      {/* Espaçador fixo: mantém o layout da página estável (sempre largura colapsada) */}
      <div style={{ width:54, minWidth:54, height:"100vh", flexShrink:0 }} />

      {/* Sidebar real: fixa na tela, expande por cima do conteúdo no hover */}
      <div
        onMouseEnter={()=>setHovering(true)}
        onMouseLeave={()=>setHovering(false)}
        style={{
          position:"fixed", top:0, left:0, zIndex:1000,
          width: collapsed ? 54 : 218,
          minWidth: collapsed ? 54 : 218,
          background:"#111827",
          borderRight:"1px solid #1e2d45",
          display:"flex", flexDirection:"column",
          height:"100vh", overflow:"hidden",
          boxShadow: collapsed ? "none" : "4px 0 24px rgba(0,0,0,0.35)",
          transition:"width 0.2s ease, min-width 0.2s ease, box-shadow 0.2s ease"
        }}>
        {/* Logo: so o icone M com o menu recolhido; logo completa quando expande */}
        <div style={{ borderBottom:"1px solid #1e2d45", boxSizing:"border-box",
          height: collapsed ? 56 : 84,
          display:"flex", alignItems:"center", justifyContent:"center",
          transition:"height 0.2s ease" }}>
          {collapsed ? (
            <img src={`${process.env.PUBLIC_URL}/icone-moobifleet-claro.png`} alt="MoobiFleet"
              style={{ width:36, height:"auto", display:"block" }} />
          ) : (
            <img src={`${process.env.PUBLIC_URL}/logo-moobifleet-claro.png`} alt="MoobiFleet"
              style={{ height:66, width:"auto", display:"block" }} />
          )}
        </div>


        {/* Menu */}
        <div className="sidebar-scroll" style={{ flex:1, overflowY:"auto", overflowX:"hidden", padding:"6px 0" }}>
          {gruposFiltrados.map(grupo => (
            <div key={grupo.id} style={{ marginBottom:2 }}>
              {!(grupo as any).semCabecalho && !collapsed && (
                <div onClick={()=>toggleGrupo(grupo.id)}
                  style={{ display:"flex", alignItems:"center", gap:8,
                    padding:"10px 14px 4px", cursor:"pointer" }}>
                  <span style={{ color:"#334155" }}>
                    <PhIcon name={(grupo as any).icon||"folder"} size={12} color="#334155" />
                  </span>
                  <span style={{ fontSize:10, color:"#334155", fontWeight:700,
                    textTransform:"uppercase", letterSpacing:"0.8px", flex:1 }}>
                    {grupo.label}
                  </span>
                  <PhIcon name={grupos[grupo.id] ? "caret-up" : "caret-down"} size={12} color="#334155" />
                </div>
              )}
              {!(grupo as any).semCabecalho && collapsed && (
                <div style={{ height:1, background:"#1e2d45", margin:"6px 8px" }} />
              )}

              {(collapsed || grupos[grupo.id]) && grupo.itens.map(item => (
                <MenuItem key={item.id} {...item} ativo={pagina===item.id}
                  onClick={()=>setPagina(item.id)} collapsed={collapsed} />
              ))}
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{ padding:"10px", borderTop:"1px solid #1e2d45" }}>
          {!collapsed ? (
            <div style={{ display:"flex", alignItems:"center", gap:8,
              padding:"6px 8px", borderRadius:10, background:"#1a2744" }}>
              <div style={{ width:28, height:28, borderRadius:"50%",
                background:"linear-gradient(135deg,#0c2a4a,#1e3a6e)",
                display:"flex", alignItems:"center", justifyContent:"center",
                fontSize:11, fontWeight:700, color:"#38bdf8", flexShrink:0 }}>
                {usuario?.nome?.charAt(0).toUpperCase()}
              </div>
              <div style={{ flex:1, overflow:"hidden" }}>
                <div style={{ fontSize:11, fontWeight:600, color:"#e2e8f0",
                  whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                  {usuario?.nome}
                </div>
                <div style={{ fontSize:9, color:"#475569", textTransform:"capitalize" }}>
                  {usuario?.perfil}
                </div>
              </div>
              <button onClick={logout} title="Sair"
                style={{ background:"none", border:"none", cursor:"pointer",
                  padding:4, borderRadius:6, display:"flex", alignItems:"center" }}>
                <PhIcon name="sign-out" size={16} color="#64748b" />
              </button>
            </div>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:8 }}>
              <div style={{ width:28, height:28, borderRadius:"50%",
                background:"linear-gradient(135deg,#0c2a4a,#1e3a6e)",
                display:"flex", alignItems:"center", justifyContent:"center",
                fontSize:11, fontWeight:700, color:"#38bdf8" }}>
                {usuario?.nome?.charAt(0).toUpperCase()}
              </div>
              <button onClick={logout} title="Sair"
                style={{ background:"none", border:"none", cursor:"pointer",
                  padding:4, display:"flex", alignItems:"center" }}>
                <PhIcon name="sign-out" size={16} color="#64748b" />
              </button>
            </div>
          )}
        </div>
      </div>
      {/* Faixa fixa enquanto o superadmin esta acessando como um usuario de cliente */}
      {acessoComo && (
        <div style={{ position:"fixed", bottom:16, left:"50%", transform:"translateX(-50%)", zIndex:3000,
          background:"#78350f", border:"1px solid #f59e0b", color:"#fef3c7", borderRadius:24,
          padding:"8px 8px 8px 18px", display:"flex", alignItems:"center", gap:14,
          fontSize:12, boxShadow:"0 6px 24px rgba(0,0,0,0.45)", maxWidth:"92vw" }}>
          <span>
            Você está acessando como <b>{acessoComo.alvo_nome}</b>{acessoComo.empresa ? ` — ${acessoComo.empresa}` : ""}
          </span>
          <button onClick={voltarAoMeuUsuario}
            style={{ background:"#f59e0b", color:"#1c1917", border:"none", borderRadius:16, padding:"6px 14px",
              fontWeight:700, fontSize:12, cursor:"pointer", whiteSpace:"nowrap" }}>
            Voltar ao meu usuário
          </button>
        </div>
      )}
    </>
  )
}
